'use strict';

angular.module('shiftTraderApp')
  .factory('Registration', function ($http, ServerUrls, $q) {
    var path = ServerUrls.current.railsApi + 'registrations/';

    return {
      createUserWithOrganization: function (hash) {
        return $http.post(path, hash)
          .then(function(response) {
            return response.data;
          }, function (response) {
            return $q.reject(response);
          });
      }
    };
  });
